import styled from 'styled-components';

import { nepal } from '@paradigm/design-system/src/colors';

export default function DefaultAccountIndicator() {
  return (
    <div css="display: flex; align-items: center; margin-right: 0.5rem;">
      <DefaultTag>default</DefaultTag>
      <i className="material-icons white-icon">arrow_drop_down</i>
    </div>
  );
}

const DefaultTag = styled.span`
  color: ${nepal};
`;
